export default function MobileNavToggle () {

    const navToggles = document.querySelectorAll('.mobile-nav__toggle');
    const navWrapper = document.getElementsByClassName('mobile-nav')[0];
    const toggleClass = 'mobile-nav--open';

    navToggles.forEach(navToggle => {
        navToggle.addEventListener('click', function handleClick(event) {
            navWrapper.classList.toggle(toggleClass);
        });
    });
}